import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'cvdollar' })

export class CvDollar implements PipeTransform {

    // transform(value: number): string {
    //     let cvdollar: any = "";
    //     if (value < 0) {
         
    //       cvdollar = "("+Math.abs(value/100)+")";
    //     }else{
    //         cvdollar = value/100;
    //     }
    //     return cvdollar;
    // }
    
    transform(value: string): string {
        let cvdollar: any = "";
        let numValue:number = 0.0;
        if(typeof(value)==='string'){
           numValue = Number(value.replace(/\$|,/g, ''));
        }
        else{
            numValue = value;
        }
        if (numValue < 0) {
            cvdollar = "("+Math.abs(numValue/100).toLocaleString('en-US', {
                minimumFractionDigits:2,
                maximumFractionDigits:2
            })+")";
        }else{
            cvdollar= Math.abs(numValue/100).toLocaleString('en-US', {
                minimumFractionDigits:2,
                maximumFractionDigits:2
            });
            
          
        }
        return cvdollar;
    }
}